import { createSelector } from 'reselect';

export const getUser = state => state.user;

const UserSelectors = {
    makeUser: createSelector([getUser], user => user),
    makeApplicationsEnabled: createSelector([getUser], user => user.applicationsEnabled),
    makeIsLoggedIn: createSelector([getUser], user => user.loggedIn),
    makeIsEmailVerified: createSelector([getUser], user => user.isEmailVerified),
    makeIsSeattleHousingConnector: createSelector([getUser], user => user.isSeattleHousingConnector),
    makeIsMultifamilyCustomer: createSelector([getUser], user => user.isMultifamilyCustomer),
    makeIsRocketshipCustomer: createSelector([getUser], user => user.isRocketshipCustomer),
    makeIsRocketshipCustomerOnly: createSelector([getUser], user => user.isRocketshipCustomerOnly),
    makeIsTwoFactorAuthEnabled: createSelector([getUser], user => user.isTwoFactorAuthEnabled),
    makeIsUserBlocked: createSelector([getUser], user => user.isUserBlocked),
    makeImpersonatorUserToken: createSelector([getUser], user => user.impersonatorUserToken),
    makeEmail: createSelector([getUser], user => user.email),
    makePhoneNumber: createSelector([getUser], user => user.phoneNumber),
    makeRoles: createSelector([getUser], user => user.roles),
    makeOriginalServerSideRequestCookies: createSelector([getUser], user => user.originalServerSideRequestCookies),
    makeHasPaidForListing: state => getUser(state).hasPaidForListing,
};

export default UserSelectors;
